import {createListenerMiddleware} from "@reduxjs/toolkit";

import {pick} from "@pg-mono/nodash";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IRootState} from "../../store/store";
import {getIsUserAuthenticatedApi} from "../../user/api/get_is_user_authenticated";
import {getUserProfileApi} from "../../user/api/get_user_profile";
import {authSucceeded} from "../actions/auth_succeeded_event";

/**
 * Listener that fetches user authentication status and profile after successful authentication.
 */
export const fetchUserDataAfterAuthListener = createListenerMiddleware<IRootState>();

fetchUserDataAfterAuthListener.startListening({
    matcher: authSucceeded.match,
    effect: async (action, listenerApi) => {
        const authPayload = action.payload;
        const authContext = pick(authPayload, ["type", "userSource", "registrationMethod"]);

        /**
         * Authentication has just succeeded, so the user is logged in no matter what the cached authentication
         * status still says. Seeding it up front keeps `selectIsUserAuthenticated` - and the `getUserProfile`
         * guard built on top of it - from treating the user as anonymous and answering with an empty profile
         * when `users/info/` is stale, cached or failing
         */
        try {
            await listenerApi.dispatch(getIsUserAuthenticatedApi.util.upsertQueryData("getIsUserAuthenticated", undefined, true));
        } catch (error) {
            notifyBugsnag(error, "Failed to mark the user as authenticated after authentication", authContext);
        }

        /**
         * The profile is fetched before the status is revalidated and each request is handled on its own -
         * a failing status request must not skip the profile, because the post-auth flow waits for it and
         * would otherwise stall on the registration form.
         *
         * The first attempt can be neutralized by consumers racing in the same tick: deduplicated against
         * a request already in flight, or answered with null by the anonymous guard while the session cache
         * was still settling. Those resolve within the attempt itself, so a single retry gets a real response
         */
        const fetchUserProfile = () => listenerApi.dispatch(getUserProfileApi.endpoints.getUserProfile.initiate(undefined, {forceRefetch: true})).unwrap();

        try {
            const userProfile = await fetchUserProfile().catch(() => null);

            if (!userProfile) {
                await fetchUserProfile();
            }
        } catch (error) {
            notifyBugsnag(error, "Failed to refresh user profile after authentication", authContext);
        }

        try {
            await listenerApi.dispatch(getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.initiate(undefined, {forceRefetch: true})).unwrap();
        } catch (error) {
            notifyBugsnag(error, "Failed to fetch user authentication status after authentication", authContext);
        }
    }
});
import {createListenerMiddleware} from "@reduxjs/toolkit";

import {pick} from "@pg-mono/nodash";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IRootState} from "../../store/store";
import {getIsUserAuthenticatedApi} from "../../user/api/get_is_user_authenticated";
import {getUserProfileApi} from "../../user/api/get_user_profile";
import {authSucceeded} from "../actions/auth_succeeded_event";

/**
 * Listener that fetches user authentication status and profile after successful authentication.
 */
export const fetchUserDataAfterAuthListener = createListenerMiddleware<IRootState>();

fetchUserDataAfterAuthListener.startListening({
    matcher: authSucceeded.match,
    effect: async (action, listenerApi) => {
        const authPayload = action.payload;
        const authContext = pick(authPayload, ["type", "userSource", "registrationMethod"]);

        /**
         * Authentication has just succeeded, so the user is logged in no matter what the cached authentication
         * status still says. Seeding it up front keeps `selectIsUserAuthenticated` - and the `getUserProfile`
         * guard built on top of it - from treating the user as anonymous and answering with an empty profile
         * when `users/info/` is stale, cached or failing
         */
        try {
            await listenerApi.dispatch(getIsUserAuthenticatedApi.util.upsertQueryData("getIsUserAuthenticated", undefined, true));
        } catch (error) {
            notifyBugsnag(error, "Failed to mark the user as authenticated after authentication", authContext);
        }

        /**
         * The profile is fetched before the status is revalidated and each request is handled on its own -
         * a failing status request must not skip the profile, because the post-auth flow waits for it and
         * would otherwise stall on the registration form.
         *
         * The first attempt can be neutralized by consumers racing in the same tick: deduplicated against
         * a request already in flight, or answered with null by the anonymous guard while the session cache
         * was still settling. Those resolve within the attempt itself, so a single retry gets a real response
         */
        const fetchUserProfile = () => listenerApi.dispatch(getUserProfileApi.endpoints.getUserProfile.initiate(undefined, {forceRefetch: true})).unwrap();

        try {
            const userProfile = await fetchUserProfile().catch(() => null);

            if (!userProfile) {
                await fetchUserProfile();
            }
        } catch (error) {
            notifyBugsnag(error, "Failed to refresh user profile after authentication", authContext);
        }

        try {
            await listenerApi.dispatch(getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.initiate(undefined, {forceRefetch: true})).unwrap();
        } catch (error) {
            notifyBugsnag(error, "Failed to fetch user authentication status after authentication", authContext);
        }
    }
});
